// @mui icons
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import InstagramIcon from '@mui/icons-material/Instagram';
import GitHubIcon from "@mui/icons-material/GitHub";

// Material Kit 2 React components
import MKTypography from "components/MKTypography";

// Images
import logoCT from "assets/images/logo-footer-fmp.png";
import link from 'assets/theme/components/link';

const date = new Date().getFullYear();

export default {
  brand: {
    name: "FMP Soluções",
    image: logoCT,
    route: "/",
  },
  socials: [
    {
      icon: <LinkedInIcon />,
      link: "https://www.linkedin.com/company/fmp-solucoes/",
    },
    {
      icon: <InstagramIcon />,
      link: "https://instagram.com/fmp.solucoes",
    },
    {
      icon: <GitHubIcon />,
      link: "https://github.com/FMPSolucoes_Publico",
    },
  ],
  menus: [
    {
      name: "Empresa",
      items: [
        { name: "Sobre nós", route: "/pages/empresa/sobre-nos" },
        { name: "Notícias", route: "/pages/empresa/noticias" },
       // { name: "Termos & Condições", route: "/pages/empresa/termos-condicoes" },
        { name: "Política de privacidade", route: "/pages/empresa/politica-privacidade" },
       // { name: "Trabalhe Conosco", route: "/pages/empresa/carreiras" },
      ],
    },  
    {
      name: "Produtos",
      items: [
        { name: "Templar", route: "/pages/produtos/templar" },
        { name: "Licenças de software", route: "/pages/produtos/licencas" },
      ],
    },
    {
      name: "Serviços",
      items: [
       // { name: "Software", href: "pages/servicos/bespoke-software" },
        { name: "Consultoria", route: "/pages/servicos/consultoria" },
        { name: "Penetration Test", route: "/pages/servicos/penetration-test" },
      ],
    },
    {
      name: "Academia Cibernética",
      items: [
        { name: "Treinamentos Ciber", route: "/pages/academia-ciber/treinamento" },
        { name: "ICEMBA", route: "/pages/academia-ciber/icemba" },
      ],
    },
    {
      name: "Centro de Excelência",
      items: [
        { name: "Projetos", route: "/pages/centro-de-excelencia/projetos" },
        //{ name: "Estágio", href: "pages/centroexcelencia/estagio" },
      ],
    },
    {
      name: "Ajuda",
      items: [
        { name: "Perguntas frequentes", route: "/pages/ajuda/faq" },
        { name: "Suporte", route: "/pages/ajuda/suporte" },
        { name: "Contato", route: "/pages/ajuda/contate-nos" },
      ],
    },
  ],
  copyright: (
    <MKTypography variant="button" fontWeight="regular">
      Todos os direitos reservados. Copyright &copy; {date} FMP Soluções por {" "}
      <MKTypography
        component="a"
        href="https://www.fmpsolucoes.com.br/"
        target="_blank"
        rel="noreferrer"
        variant="button"
        fontWeight="regular"
      >
        administrador
      </MKTypography>
      .
    </MKTypography>
  ),
};